import { Typography, Box } from "@mui/material";
import { makeStyles } from '@mui/styles';
import './slider.css';
import QuestionMarkSvg from './QuestionMarkSvg'
import { useViewport } from "../viewportListener";

const useStyles = makeStyles((theme) => ({
  outerDiv: {
    // Add any outer div styles here
  },
  typography2: {
    fontWeight: "500",
    fontSize: '11px',
    [theme.breakpoints.up('md')]: {
      fontSize: '16px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '18px',
    },
  },
}));

const TypographyPercentageBar = ({ value, positive = true, style,isMobile=false }) => {
  const classes = useStyles();
  // Update the width and text when the value changes

  const absValue = Math.abs(value);
  const width = absValue * 100 + "%";
  let wd = absValue * 100;
  if(isMobile===false){
    wd=wd+50;
  }
  // const valueNumber=value;
  // const text= {valueNumber > 0 ? "+" + Math.round(value * 100) + "%" : value < 0 ? "-" + Math.round(value * 100) + "%": Math.round(value * 100) + "%"};
  const valueNow = Math.round(value * 100);
  const text = `${valueNow > 0 ? "+" + Math.round(value * 100) + "%" : Math.round(value * 100) + "%"}`;

  // Determine the bar color based on the value
  const gradient = positive ? `linear-gradient(269.77deg, #4F9F65 41.36%, rgba(79, 159, 101, 0) 100%)` : `linear-gradient(89.36deg, #E66262 31.38%, rgba(230, 98, 98, 0) 100%)`;

  // Set a minimum width for the bar and adjust the font size of the text
  const minWidth = "25px";
  const fontSize = wd < minWidth ? "10px" : "16px";
  let wdPx=wd+"px";

  return (
    <div 
    // className="percentageBarDiv" 
    style={{ height: "35px",minWidth:"50px" }}>
      {/* <div style={{}}> */}

        <Box
          sx={{
            color: "white",
            background: gradient,
            textAlign: positive ? "right" : "left",
            width: wdPx,
            minWidth: "fit-content",
            // maxWidth: "70px",
            borderRadius: "5px",
            padding: "5px",
            top: "0",
            ...style,
          }}>
          <Typography className={classes.typography2}

          >
            {text}
          </Typography>
        </Box>
        {/* <div style={{}}>
          {
           positive ?
              (
                <QuestionMarkSvg /> 
              ) : (
                <div />
              )}
        </div> */}
      {/* </div> */}
    </div>
  );
};

export default TypographyPercentageBar;
